import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-about',
  templateUrl: './about.component.html'
})
export class AboutComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
